<template>
  <Popper placement="right" :show="isRoutePopperOpened">
    <button @click="checkStoppages" class="bg-transparent border-0">
      <i role="button" class="fa-solid fa-route px-2"></i>
    </button>
    <template #content>
      <div id="route-editor">
        <div class="text-end me-4 mb-2">
          <button class="btn btn-sm btn-danger" @click="closePopper">
            Zamknij edytor <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div class="fw-bold text-primary">
          Obecna trasa:
          <input type="text" placeholder="Wpisz trasę" style="width: 300px" ref="routeText" class="ms-2" v-model="routeText">
          <button role="button" class="btn border" @click="routeUpdate"><i class="fa-solid fa-check"></i></button>
        </div>
        <div class="separate-line"></div>
        <div class="stoppages-list">
          <div class="table-header">
            <strong>akronim, </strong>
            <strong>przyjazd, </strong>
            <strong>wyjazd, </strong><br>
            <strong style="color: #3399FF;">akronim przepinki, </strong>
            <strong style="color: #ff471a;">szerokość geo, </strong>
            <strong style="color: #ff9900;">wysokość geo</strong>
          </div>
          <div style="display:flex;">
            <table class="stoppages-list-table" id="StoppagesListTable" ref="StoppagesListTableRef">
              <tr v-for="(stoppage, i) in stoppages" :key="stoppage.id">
                <td>
                  <strong class="stoppage-data">{{ stoppage.acronym }}</strong>
                </td>
                <td class="stoppage-data">
                  {{ moment(stoppage.arrival).tz('Europe/Warsaw').format('DD.MM.YYYY HH:mm') }}
                  <button @click="updateStoppage(stoppage, 'arrival', i)">
                    <i class="fas fa-edit"></i>
                  </button>
                </td>
                <td class="stoppage-data">
                  {{ stoppage.departure ? moment(stoppage.departure).tz('Europe/Warsaw').format('DD.MM.YYYY HH:mm') : 'Brak daty' }}
                  <button @click="updateStoppage(stoppage, 'departure', i)">
                    <i class="fas fa-edit"></i>
                  </button>
                </td>
                <td>
                  <button @click="removeStoppage(i)">
                    <i class="fas fa-x"></i>
                  </button>
                </td>
              </tr>
            </table>
            <div class="plus-col" @click="this.clickPlusColFn()" ref="plusColRef">

            </div>
          </div>
        </div>
        <div class="separate-line" style="margin: 5px auto;"></div>
        <div class="stoppage-add-sect">
          <button class="add-btn" type="button" @click="showPanel() " id="addStoppagesBtnOpen" ref="addStoppagesBtnOpenRef">dodaj&nbsp;<i class="fa-solid fa-plus"></i></button>
          <button class="add-btn" type="button" @click="hidePanel()" id="addStoppagesBtnClose" style="display: none;" ref="addStoppagesBtnCloseRef">zamknij&nbsp;<i class="fa-solid fa-x"></i></button>
          <div class="stoppage-form" ref="stoppageForm" style="display: none;">
            <label class="mt-2" for="acronymInput">Wprowadź szukany akronim</label>
            <input type="text" id="acronymInput" @input="fetchPlacesFn()" v-model="acronymsSearchText" ref="acronymInputRef">
            <select name="acronymSelect" id="acronymSelect" ref="acronymSelectRef">
              <option value="startTxt" ref="defaultOption" >---tutaj pojawią się szukane akronimy---</option>
              <option v-for="(acronym, index) in foundAcronyms" :key="index" :value="acronym">
                {{ acronym }}
              </option>
            </select>
            <label class="mt-2" for="arrivalInput">przyjazd</label>
            <input type="datetime-local" id="arrivalInput" ref="arrivalInputRef">
            <label class="mt-2" for="departureInput">wyjazd</label>
            <input type="datetime-local" id="departureInput" ref="departureInputRef">
            <button type="button" id="submitPlaceBtn" style="border:none; margin-top: 3px;" @click="submitStoppagesFn()"><b>Zatwierdź</b></button>
          </div>
        </div>
      </div>
    </template>
  </Popper>
</template>

<script>
import Popper from 'vue3-popper'
import Swal from 'sweetalert2'
import emitter from '@/modules/events/emitter'
import { mapGetters } from 'vuex'
import Moment from 'moment-timezone'
import moment from 'moment-timezone'
import { extendMoment } from 'moment-range'
import { $axios } from '@/modules/http/axios'
import { validateArrival, validateDeparture } from '@/modules/task/stoppagesValidator'

export default {
  name: 'AttachedRoute',
  components: { Popper },
  props: ['task'],
  data () {
    return {
      arrival: null,
      departure: null,
      stoppages: [],
      currentTaskResult: {},
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      foundAcronyms: [],
      acronymsSearchText: '',
      moment: moment,
      routeText: this.task.trasa,
      isRoutePopperOpened: false
    }
  },
  created () {
    emitter.on('routeEditorOpened', e => {
      if (e.taskId !== this.task.id) {
        this.isRoutePopperOpened = false
      }
    })
  },
  computed: {
    ...mapGetters({
      places: 'getPlaces'
    })
  },
  methods: {
    fetchPlacesFn() {
      setTimeout(() => {
        if (this.acronymsSearchText.length > 1) {
          this.foundAcronyms = this.places.filter(p => p.acronym.toLowerCase().includes(this.acronymsSearchText)).map(p => p.acronym).slice(0, 30)
        }
      }, 1000)
    },
    showPanel(){
      const stoppageForm = this.$refs.stoppageForm
      const addStoppagesBtnOpenRef = this.$refs.addStoppagesBtnOpenRef
      const addStoppagesBtnCloseRef = this.$refs.addStoppagesBtnCloseRef
      stoppageForm.style = "display: flex;"
      addStoppagesBtnOpenRef.style = "display: none;"
      addStoppagesBtnCloseRef.style = "display: inline-block;"
    },
    hidePanel(){
      const stoppageForm = this.$refs.stoppageForm
      const addStoppagesBtnOpenRef = this.$refs.addStoppagesBtnOpenRef
      const addStoppagesBtnCloseRef = this.$refs.addStoppagesBtnCloseRef
      stoppageForm.style = "display: none;"
      addStoppagesBtnOpenRef.style = "display: inline-block;"
      addStoppagesBtnCloseRef.style = "display: none;"
    },
    checkStoppages(){
      this.openPopper()
      this.$store.dispatch('fetchPlaces')
      this.resetForm()
      this.addBetweenBtnsFn()

      $axios.get(`Task/${this.task.id}`).then(response => {
        this.stoppages = response.data.stoppages
      })
    },
    submitStoppagesFn(){
      const acronymSelectReff = this.$refs.acronymSelectRef
      const arrivalInputReff = this.$refs.arrivalInputRef.value
      const departureInputReff = this.$refs.departureInputRef.value

      if (acronymSelectReff.value === "startTxt" || arrivalInputReff === "" || departureInputReff === "") {
        Swal.fire("Proszę uzupełnić wszystkie pola", "", "error")
      } else {
        $axios.get(`Task/${this.task.id}`)
          .then(response => {
            const acronymSelectRef = this.$refs.acronymSelectRef
            const arrivalInputRef = this.$refs.arrivalInputRef.value
            const departureInputRef = this.$refs.departureInputRef.value

            let currentStoppageData = {
              acronym: acronymSelectRef.value,
              przyjazd: `${arrivalInputRef}:00.000Z`,
              wyjazd: `${departureInputRef}:00.000Z`
            }

            let stoppagesArr = []

            if (Object.keys(response.data.stoppages).length !== 0) {
              response.data.stoppages.forEach(y => {
                let previousStoppageData = {}
                previousStoppageData.acronym = y.acronym
                previousStoppageData.przyjazd = y.arrival
                previousStoppageData.wyjazd = y.departure
                stoppagesArr.push(previousStoppageData)
              })
          }

          stoppagesArr.push(currentStoppageData)

          let stoppagesArr2 = this.sortDatesFn(stoppagesArr)
          let stpgsToPut = []

          stoppagesArr2.forEach(a => {
            let stpgToPut = {
              acronym: a.acronym,
              przyjazd: moment(a.przyjazd).tz('Europe/Warsaw'),
              wyjazd: a.wyjazd,
              backgroundColor: a.backgroundColor ?? '#ffffff'
            }
            stpgsToPut.push(stpgToPut)
          })

          let stoppagesRoute = []

          stoppagesArr2.forEach(c => {
            stoppagesRoute.push(c.acronym)
          })

          const putData = {
            postoje: stpgsToPut,
            zaladunek: stpgsToPut[0].przyjazd,
            rozladunek: stoppagesArr2[stoppagesArr2.length - 1].przyjazd,
            trasa: stoppagesRoute.join('->')
          }

          let currentStoppageValid = true
          let errorMessage = ''

          this.task.stoppages?.map(s => {
            const moment = extendMoment(Moment)

            const taskLoadingTime = moment(this.task.zaladunek).tz('Europe/Warsaw')
            const taskUnloadingTime = moment(this.task.rozladunek).tz('Europe/Warsaw')

            const currentStoppageArrival = moment(currentStoppageData.przyjazd).tz('Europe/Warsaw')
            const currentStoppageDeparture = moment(currentStoppageData.wyjazd).tz('Europe/Warsaw')

            const arrival = moment(s.arrival).tz('Europe/Warsaw')
            const departure = moment(s.departure ?? s.arrival).tz('Europe/Warsaw')

            const currentStoppageRange = moment.range(currentStoppageArrival, currentStoppageDeparture)
            const stoppageRange = moment.range(arrival, departure)

            if (currentStoppageArrival.isBefore(taskLoadingTime)) {
              currentStoppageValid = false
              errorMessage = 'Data przyjazdu postoju nie może być wcześniejsza niż data załadunku zlecenia'
            }

            if (currentStoppageDeparture.isAfter(taskUnloadingTime)) {
              currentStoppageValid = false
              errorMessage = 'Data wyjazdu postoju nie może być późniejsza niż data rozładunknu zlecenia'
            }

            if (currentStoppageDeparture.isBefore(currentStoppageArrival)) {
              currentStoppageValid = false
              errorMessage = 'Data przyjazdu postoju nie może być późniejsza niż data jego wyjazdu'
            }

            if (currentStoppageRange.overlaps(stoppageRange)) {
              currentStoppageValid = false
              errorMessage = 'Daty postojów nie mogą pokrywać się na przestrzeni czasu'
            }
          })

          if (!currentStoppageValid) {
            Swal.fire(
              'Zmiana niemożliwa, sprawdź godziny dodawanego postoju',
              errorMessage,
              'warning'
            )
          } else {
            $axios.put(`Task/${this.task.id}`, putData).then(() => {
              Swal.fire("Pomyślnie dodano postój", "", "success")
              emitter.emit('taskChanged', { taskId: this.task.id })
              this.checkStoppages()
            }).catch(error => {
              Swal.fire(`Nie udało się dodać postoju o akronimie ${currentStoppageData.acronym}`)
              console.log(error)
            })
          }
        }).catch(error => console.log('error', error))
      }
    },
    resetForm(){
      const defaultOption =  this.$refs.defaultOption
      const acronymInputRef = this.$refs.acronymInputRef
      const arrivalInputRef = this.$refs.arrivalInputRef
      const departureInputRef = this.$refs.departureInputRef

      defaultOption.selected = true
      acronymInputRef.value = ""
      arrivalInputRef.value = ""
      departureInputRef.value = ""
    },
    async routeUpdate () {
      await $axios.put(`Task/${this.task.id}`, { trasa: this.routeText })
      emitter.emit('taskChanged', { taskId: this.task.id })
    },
    async removeStoppage (i) {
      const postoje = []
      this.stoppages.splice(i, 1)

      this.stoppages.map(s => postoje.push({
        acronym: s.acronym,
        przyjazd: s.arrival,
        wyjazd: s.departure,
        backgroundColor: s.backgroundColor ?? '#FFFFFF'
      }))

      await $axios.put(`Task/${this.task.id}`, { postoje: postoje })
      emitter.emit('taskChanged',  { taskId: this.task.id })
      this.checkStoppages()
    },
    addBetweenBtnsFn(){
      const plusColRef = this.$refs.plusColRef
      plusColRef.querySelectorAll("button").forEach(e => e.remove())

      $axios.get(`Task/${this.task.id}`).then(result => {
        if (!result.data.stoppages.length) {
          let arrivalsAndDeparturesArr = []
          this.createPlusFn("0", result.data.stoppages[0]?.departure)
          result.data.stoppages.forEach(c => {
            arrivalsAndDeparturesArr.push(c.arrival)
            arrivalsAndDeparturesArr.push(c.departure)
          })
          for (let f = 1; f<arrivalsAndDeparturesArr.length / 2; f++) {
            this.createPlusFn(arrivalsAndDeparturesArr[f], arrivalsAndDeparturesArr[f+1])
          }
          this.createPlusFn(result.data.stoppages[result.data.stoppages.length - 1]?.arrival, "")
        }
      }).catch(error => console.log('error', error))
    },
    createPlusFn(arv, dpr){
      const plusColRef = this.$refs.plusColRef
      const newPlus = document.createElement("button")
      newPlus.innerHTML = "<i class='fa-solid fa-plus'></i>"
      newPlus.setAttribute("data-arrival", arv)
      newPlus.setAttribute("data-departure", dpr)
      newPlus.setAttribute("onclick", "this.setAttribute('data-isClicked', true)")
      plusColRef.appendChild(newPlus)
    },
    clickPlusColFn(){
      const plusColRef = this.$refs.plusColRef
      let dataToFill = {}
      dataToFill.arrivalProperty = plusColRef.querySelector("button[data-isClicked='true']").dataset.arrival
      dataToFill.departureProperty = plusColRef.querySelector("button[data-isClicked='true']").dataset.departure
      this.showPanel()
      this.$refs.arrivalInputRef.value = dataToFill.arrivalProperty
      this.$refs.departureInputRef.value = dataToFill.departureProperty
    },
    sortDatesFn(arr){
      if(arr.length > 1){
        let times = []
        arr.forEach(a => {
          let splittedAarrival = a.przyjazd.split('')
          let arrArrivalYear = `${splittedAarrival[0]}${splittedAarrival[1]}${splittedAarrival[2]}${splittedAarrival[3]}`
          let arrArrivalMonth = `${splittedAarrival[5]}${splittedAarrival[6]}`
          let arrArrivalDay = `${splittedAarrival[8]}${splittedAarrival[9]}`
          let arrArrivalHour = `${splittedAarrival[11]}${splittedAarrival[12]}`
          let arrArrivalMin = `${splittedAarrival[14]}${splittedAarrival[15]}`
          times.push(`${this.months[arrArrivalMonth - 1]} ${arrArrivalDay} ${arrArrivalYear} ${arrArrivalHour}:${arrArrivalMin}`)
        })
        for (const x in arr) {
          arr[x].przyjazd = new Date(times[x])
          arr[x].przyjazd2 = arr[x].przyjazd
        }
        return arr.sort((a, b) => a.przyjazd2 - b.przyjazd2);
      }else{
        return arr;
      }
    },
    async updateStoppage (stoppage, key, stoppageIndex) {
      const oldDate = key === 'arrival' ? stoppage.arrival : stoppage.departure

      await Swal.fire({
        title: `Zaktualizuj datę ${key === 'arrival' ? 'przyjazdu' : 'wyjazdu'} w postoju ${stoppage.acronym}`,
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: 'Anuluj',
        showConfirmButton: true,
        confirmButtonText: 'Zatwierdź',
        html: `
            <div>${key === 'arrival' ? 'Data przyjazdu' : 'Data wyjazdu'}:</div>
            <input class="form-control" id="new-date" type="datetime-local" value="${moment(oldDate).format('YYYY-MM-DD HH:mm')}" required>
          `,
        preConfirm: () => {
          return new Promise(resolve => {
            const date = document.getElementById('new-date').value

            if (key === 'arrival') { stoppage.arrival = date }
            if (key === 'departure') { stoppage.departure = date }

            const currentStoppageValid = this.checkStoppagesOverlapping(this.stoppages, stoppage, stoppageIndex)

            if (date === '') {
              Swal.fire('Proszę uzupełnić datę', '', 'warning')
            } else if (!currentStoppageValid) {
              this.checkStoppages()
              Swal.fire(
                'Zmiana niemożliwa, sprawdź godziny dodawanego postoju',
                'Godzina przyjazdu i wyjazdu nie może pokrywać się z czasem innego postoju w zleceniu. Załadunek postoju nie może także być późniejszy niż rozładunek.',
                'warning'
              )
            } else {
              resolve(date)
            }
          }).then(result => {
            let isValid = true
            let message = ''

            if (key === 'arrival') {
              this.stoppages[stoppageIndex].arrival = result

              if (stoppageIndex === this.stoppages.length - 1) {
                this.stoppages[stoppageIndex].departure = result
              }

              const arrivalValidation = validateArrival(this.stoppages, stoppageIndex, result, isValid, this.task)
              isValid = arrivalValidation.isValid
              message = arrivalValidation.message
            }

            if (key === 'departure') {
              this.stoppages[stoppageIndex].departure = result

              if (stoppageIndex === this.stoppages.length - 1) {
                this.stoppages[stoppageIndex].arrival = result
              }

              const departureValidation = validateDeparture(this.stoppages, stoppageIndex, result, isValid, this.task)
              isValid = departureValidation.isValid
              message = departureValidation.message
            }

            if (!isValid) {
              this.checkStoppages()
              Swal.fire(message, '', 'error')
            } else {
              this.stoppages.map(async s => {
                await $axios.put(`Stoppages/${s.id}`, {
                  acronym: s.acronym,
                  arrival: s.arrival,
                  departure: s.departure,
                  backgroundColor: s.backgroundColor ?? '#FFFFFF'
                })
              })

              const putData = {
                zaladunek: this.stoppages[0].arrival,
                rozladunek: this.stoppages[this.stoppages.length - 1].arrival
              }

              this.updateTask(putData)
            }
          })
        }
      })
    },
    updateTask (putData) {
      $axios.put(`Task/${this.task.id}`, putData)
        .then(() => {
          Swal.fire('Pomyślnie zaktualizowano godzinę', '', 'success')
          emitter.emit('taskChanged', { taskId: this.task.id })
        })
        .catch(() => Swal.fire('Nie udało się zaktualizować godziny', '', 'error'))
    },
    checkStoppagesOverlapping (stoppages, currentStoppageData, currentStoppageIndex) {
      let currentStoppageValid = true

      stoppages.map((s, i) => {
        const moment = extendMoment(Moment)

        const currentStoppageArrival = moment(currentStoppageData.arrival).tz('Europe/Warsaw')
        const currentStoppageDeparture = moment(currentStoppageData.departure).tz('Europe/Warsaw')

        const arrival = moment(s.arrival).tz('Europe/Warsaw')
        const departure = moment(s.departure ?? s.arrival).tz('Europe/Warsaw')

        const currentStoppageRange = moment.range(currentStoppageArrival, currentStoppageDeparture)
        const stoppageRange = moment.range(arrival, departure)

        if (currentStoppageRange.overlaps(stoppageRange) && currentStoppageIndex !== i) {
          currentStoppageValid = false
        }
      })

      return currentStoppageValid
    },
    openPopper () {
      this.isRoutePopperOpened = true
    },

    closePopper () {
      emitter.emit('routeEditorOpened', { taskId: this.task.id })
      this.isRoutePopperOpened = false
    }
  }
}
</script>

<style>
  .separate-line{
    width: 80%;
    height: 2px;
    background-color: #000;
    margin: 0 auto;
  }
  .stoppages-list-table tr td{
    padding: 2px 3px;
    border-bottom: 1px solid #000;
  }
  .stoppages-list-table tr td:nth-child(odd){
    background-color: rgb(178, 178, 178);
  }
  .stoppages-list-table tr td:nth-child(even){
    background-color: rgb(219, 219, 219);
  }
  .table-header{
    width: 100%;
    text-align: left;
  }
  .stoppage-form{
    display: flex;
    flex-direction: column;
  }
  .add-btn{
    border: none;
  }
  .no-stoppages-alert{
    background-color: rgb(176, 58, 58) !important;
  }
  .stoppages-list{
    width: auto !important;
  }
  .stoppages-list-table{
    width: 500px;
    margin: 24px 0;
  }
  .plus-col{
    display: flex;
    flex-direction: column;
    /* background-color: gray; */
    width: 20px;
    justify-content: space-between;
  }
  .plus-col button{
    border: none;
    background-color: transparent;
  }
  #route-editor {
    max-width: 522px;
  }
</style>
